import React from 'react'
import { Load } from '../../shared'

const rows = [...Array(5)]
const cols = [...Array(5)]

export const Placeholder = (props) => {
  return (
    <div className="card p-t-0" style={{ height: 'calc(100vh - 186px)' }}>
      <div className="card-body p-t-0">
        <div className="card-body-fill">
          <Load height={64} />
        </div>
        {rows.map((_, i) => (
          <div key={i} className="row row-wide p-y-5">
            <Load width={200} height={24} className="m-r-80" />
            {cols.map((_, i) => (
              <Load key={i} width={60} height={24} />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
